import * as actionTypes from "../actionTypes";

const initialState = {
  settingTolidData: null,
  settingMaliData: null,
  settingDesignData: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SETTIND_TOLID_SUCCESS:
      return {
        ...state,
        settingTolidData: action.settingTolidData,
      };
    case actionTypes.SETTIND_MALI_SUCCESS:
      return {
        ...state,
        settingMaliData: action.settingMaliData,
      };
    case actionTypes.SETTIND_DESIGN_SUCCESS:
      return {
        ...state,
        settingDesignData: action.settingDesignData,
      };

    default:
      return state;
  }
};

export default reducer;
